import styled from 'styled-components';

export const SpamCheckerContainer = styled.div`
	height: 35px;
	display: flex;
	align-items: center;
`;
